import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';
import { Payment } from 'src/shared/types/common';

export const paymentTypeColumn = (t: TFunction): ColumnType<Payment> => ({
  title: t('Payment type'),
  key: 'paymentType',
  render: (_, item) => t(item.type),
});
